"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Link = ({
  component,
  url,
  label,
  id,
  count,
  handleClick
}) => {
  if (component) {
    return component;
  }

  return /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    onClick: e => handleClick(e, {
      url,
      label,
      id
    })
  }, label, " ", count ? /*#__PURE__*/_react.default.createElement("span", {
    className: "count"
  }, "(", count, ")") : null);
};

Link.propTypes = {
  component: _propTypes.default.object,
  url: _propTypes.default.string,
  label: _propTypes.default.string,
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  count: _propTypes.default.number,
  handleClick: _propTypes.default.func
};
var _default = Link;
exports.default = _default;